import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";
import image1 from "assets/img/feb1120193.png";
import image2 from "assets/img/feb1120194.png";

class ProductSection extends React.Component {
  state = {
    open: false,
    expanded: null,
  };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    // const { expanded } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer justify="center" style={{ textAlign: "left", color: "black" }}>
            <GridItem xs={12} sm={12} md={10}>
              <Card>
                <CardBody>
                  <span style={{ marginBottom: 0 }}>12 Februari 2019, 08.00 PM</span>
                  <h2 style={{ color: "#4BB64B", marginTop: 0 }}><b>Public Training 1.0: Awareness Training System ISO 45001:2018 & Occupational Safety and Health (SMK3)</b></h2>
                  <span style={{ fontSize: 18 }}>
                    <br />
                    <center>
                      <img src={image1} alt="Images" style={{ width: 624, height: 404, marginRight: 25 }} />
                    </center> <br /><br />
                    <p style={{ fontSize: 18 }}>
                      Pada hari kamis tanggal 7 Februari 2019 Sandton Consulting mengadakan program Public Training 1.0 yang diselenggarakan dengan tema “Awareness Training System ISO 45001:2018 & Occupational Safety and Health (SMK3)” bertempat di Satu Atap Co-Working Place and Food Street, Surabaya.
                    </p>
                    <p style={{ fontSize: 18 }}>
                      Tujuan dari acara ini memberikan pengenalan kepada perwakilan dari perusahaan mengenai Kesehatan dan Keselamatan Kerja (K3). Pengetahuan tentang K3 sangat diperlukan bagi perusahaan diberbagai jenis bidang usaha. Berikut fungsi K3 secara umum:
                    </p>
                    <ol>
                      <li>Sebagai pedoman untuk indentifikasi dan penilaian akan risiko dan bahaya bagi kesehatan dan keselamatan dilingkungan kerja</li>
                      <li>Sebagai pedoman dalam memantau kesehatan dan keselamatan para pekerja</li>
                      <li>Memberikan edukasi dan pelatihan mengenai kesehatan dan keselamatan kepada para pekerja</li>
                      <li>Sebagai pedoman dalam membuat program pengendalian bahaya dalam lingkungan kerja</li>
                      <li>Sebagai acuan dalam mengukur efektivitas tindakan pegendalian bahaya.</li>
                    </ol>
                    <p style={{ fontSize: 18 }}>
                    Pemerintah Indonesia sendiri sejak tahun 1970 sudah mengeluarkan Undang Undang No.1 tahun 1970 berisi 11 Bab dan 18 Pasal.  Undang-undang ini bersifat preventif dengan tujuan memberikan perlindungan atas keselamatan kerja. Atas dasar hukum inilah pemerintah pada akhirnya membuat PP No 50 Tahun 2012 untuk penerapan Sistem Manajemen Keselamatan dan Kesehatan Kerja (SMK3). Sistem ini diwajibkan bagi perusahaan yang memperkerjakan paling sedikit 100 orang atau perusahaan yang memiliki tingkat potensi bahaya tinggi. 
                    </p>
                    <p style={{ fontSize: 18 }}>
                    Tahun 2007 standar internasional untuk K3 pertama kali diterbitkan dengan nama Occupational Health and Safety Assesment Series (OHSAS) 18001, tujuannya juga sama dengan peraturan pemerintah yaitu memberikan perlindungan terhadap tenaga kerja terhadap bahaya yang ditimbulkan dari lingkungan kerja yang berdampak pada kesehatan dan keselamatan kerja. Tahun 2018 tepatnya bulan Maret, International Organization for Standardization (ISO) menyempurnakan sistem OHSAS 18001 dengan menerbitkan standar ISO 45001. Standar inilah yang nantinya diatur untuk menggantikan standar OHSAS, dengan masa transisi 3 tahun (sampai tahun 2021).
                    </p>
                    <p style={{ fontSize: 18 }}>
                    Kedua sistem manajemen ini yaitu standar nasional SMK3 dan standar internsional ISO 45001 memiliki tujuan yang sama dan pada akhirnya jika sistem manajemen ini diterapkan secara berkesinambungan memberikan dampak positif bagi perusahaan dan meningkatkan produktivitas perusahaan juga mengurangi tingkat kecelakaan dan menekan angka kematian tenaga kerja di lingkungan kerja.
                    </p>
                    <br />
                    <center>
                      <img src={image2} alt="Images2" style={{ width: 624, height: 404, marginRight: 25 }} />
                    </center> <br /><br />
                    <p style={{ fontSize: 18 }}>
                    Terima kasih kepada para peserta yang sudah hadir dan mengikuti pelatihan ini sampai selesai, semoga pelatihan yang sudah diberikan bermanfaat dan berguna bagi para peserta dan perusahaan anda. Salam Sukses!
                    </p>
                    <br />
                  </span>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div >
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/News/Sections/ProductSection.9.jsx